import React from 'react';

const appUrl = 'https://barnbeckmedia.com/wp-json/wp/v2/';
const getPosts = `${appUrl}posts`;

export { appUrl, getPosts } 